import ClientsAxios from '../client-axios';
import { ForgotPasswordRequest, LoginRequest, ResetPasswordRequest } from '../dto/request/auth';
import { LoginResponse } from '../dto/response';
import { handleGetRequest, handlePostRequest } from './requestHandler';
const { COMMUNITY_HEALTH_CAMP_SERVER } = ClientsAxios;

export const loginService = (payload: LoginRequest) => handlePostRequest<LoginResponse>('user/login', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const forgotPasswordService = (payload: ForgotPasswordRequest) => handlePostRequest<any>('user/forgot-password', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const resetPasswordService = (payload: ResetPasswordRequest) => handlePostRequest<any>('user/reset-password', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchRoleListService = (payload: any) => handlePostRequest<any>('roles/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const StoreUpdateUserDetailsService = (payload: any, IsUpdate: boolean) => handlePostRequest<any>(IsUpdate ? 'user/update' : 'user/register', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchPinCodeDataService = (payload: any) => handlePostRequest<any>('pincode', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchUserDetailsService = (payload: any) => handlePostRequest<any>('user/details', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchUserTypeListService = (payload: any) => handlePostRequest<any>('user-type/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const GetCaptchImageService = (payload: any) => handleGetRequest<any>('captcha/get', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const VerifyCaptchaService = (payload: any) => handlePostRequest<any>('captcha/verify', payload, COMMUNITY_HEALTH_CAMP_SERVER);

//logoutService
export const logoutService = (payload: any) => handlePostRequest<any>('user/logout', payload, COMMUNITY_HEALTH_CAMP_SERVER);